// @flow
import { communicationsError, communicationsInProgress, communicationsSuccess } from "./communications";
import { join } from "../channel";
import type { Dispatch } from "redux";

export const SAVE_MONTHLY_LEADERS = "SAVE_MONTHLY_LEADERS";

export function getMonthlyLeaders(month: number, year: number) {
  return (dispatch: Dispatch) => {
    dispatch(communicationsInProgress("getMonthlyLeaders"));
    let channel = getTournamentListChannel();

    channel.push("get_monthly_leaders", { month: month, year: year }).receive("ok", (response) => {
      dispatch(communicationsSuccess("getMonthlyLeaders"));
      dispatch(saveMonthlyLeaders((response)));
    }).receive("error", ({ message }) => {
      console.error(message);
      dispatch(communicationsError("getMonthlyLeaders", message));
    });
  };
}

function getTournamentListChannel() {
  return join("tournament:list:" + window.env.whiteLabelSite, null, undefined, null);
}

function saveMonthlyLeaders(monthlyLeaders) {
  return { type: SAVE_MONTHLY_LEADERS, monthlyLeaders };
}
